class MainSearch extends HTMLElement {
  constructor() {
    super()
    this.route = '/search'
    this.input = this.querySelector('.template-search input[type="search"]')
    this.tabPanels = [...this.querySelectorAll('.js-tabpanel')]
    this.parent = this.closest('div')
    this.tempTotalWrapper = this.querySelector('.template-search__wrapper')
    this.tempTotal = 0
    this.faqs = questionsDB
    this.initialize()
  }

  initialize() {
    const form = this.querySelector('form.search')
    form.addEventListener('submit', this.onFormSubmit.bind(this))

    this.input.addEventListener(
      'input',
      this.debounce((event) => {
        this.onChange(event)
      }, 300).bind(this)
    )

    this.renderFaqResults()

    this.tabPanels.forEach((tabPanel, i) => {
      this.onTabPanel(tabPanel)
    })

    this.updateCounter()
  }

  updateCounter() {
    const counter = this.querySelector('.total-counter')
    if (counter) {
      counter.textContent = this.tempTotal
    }
  }

  onTabPanel(tabPanel) {
    const loadMore = tabPanel.querySelector('.load-more')
    const limit = tabPanel.dataset.limit || 0
    const step = tabPanel.dataset.step || 0
    const pageCount = Math.ceil(limit / step)

    let currentPage = 1
    currentPage = this.showItems(
      tabPanel,
      currentPage,
      limit,
      step,
      pageCount,
      loadMore
    )

    this.unsetLiveRegionLoadingState()

    if (loadMore) {
      loadMore.addEventListener('click', () => {
        currentPage = this.showItems(
          tabPanel,
          currentPage + 1,
          limit,
          step,
          pageCount,
          loadMore
        )
      })
    }
  }

  getQuery() {
    return this.input.value.trim()
  }

  onFormSubmit(event) {
    if (!this.getQuery().length) event.preventDefault()
  }

  onChange() {
    const searchTerm = this.getQuery()

    if (!searchTerm.length) {
      return
    }

    if (searchTerm.length < 3) {
      return
    }

    this.getSearchResults(searchTerm)
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(' ', '-').toLowerCase()
    this.setLiveRegionLoadingState()

    fetch(
      `${this.route}?q=${encodeURIComponent(searchTerm)}&section_id=main-search`
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status)
          this.unsetLiveRegionLoadingState()
          throw error
        }

        return response.text()
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('.main-search__wrapper').innerHTML
        this.renderSearchResults(resultsMarkup)
      })
      .catch((error) => {
        this.unsetLiveRegionLoadingState()
        throw error
      })
  }

  renderSearchResults(resultsMarkup) {
    this.parent.innerHTML = resultsMarkup
    this.unsetLiveRegionLoadingState()
    this.renderFaqResults()
  }

  getFaqResults(items, fields) {
    const searchTerm = this.getQuery()
    if (!this.faqs.length || !searchTerm.length || searchTerm.length < 3)
      return []

    var q = new RegExp('\\b' + searchTerm + '\\b', 'ig')
    var found = items.filter(function (item) {
      var foundAny = false
      fields.forEach(function (field) {
        foundAny = foundAny || item[field].search(q) > -1
      })
      return foundAny
    })
    return found
  }

  renderFaqResults() {
    let results = ''
    let faqTab = document.getElementById('faq-panel-search')
    this.tempTotal = this.tempTotalWrapper.dataset.liquidTotal

    if (faqTab) {
      let faqCounter = document.getElementById('faq-counter-search')
      let faqResults = this.getFaqResults(this.faqs, ['title', 'body'])
      faqTab.setAttribute('data-limit', faqResults.length)
      this.tempTotal = Number(this.tempTotal) + Number(faqResults.length)

      if (faqResults.length) {
        results = faqTab.querySelector('ul')
        if (results) {
          results.innerHTML = ''

          faqResults.forEach((question) => {
            results.innerHTML += `
                <li class="grid__item slider__slide hidden">
                <div class="faq_wrapper">
                    <h5 class="title">${question.title}</h5>
                    <a href="/pages/faq#${question.id}">View</a>
                </div>
                </li>`
          })
        }

        faqCounter.textContent = `(${faqResults.length})`
      }

      faqTab.innerHTML = ''
      if (results) {
        faqTab.appendChild(results)
      }

      if (faqResults.length) {
        results.insertAdjacentHTML(
          'afterend',
          `
            <div class="load-more__wrapper">
                <p class="counter"></p>
                <button role="button" class="load-more hidden">${__GLOBAL__.translate.general.search.load_more}</button>
            </div>
        `
        )
      }

      this.onTabPanel(faqTab)
    }
  }

  setLiveRegionLoadingState() {
    this.setAttribute('loading', true)
  }

  unsetLiveRegionLoadingState() {
    this.removeAttribute('loading')
  }

  showItems(tabPanel, pageIndex, limit, step, pageCount, loadMore) {
    this.showLoadMore(pageCount, pageIndex, loadMore)

    const startRange = (pageIndex - 1) * step
    const endRange = pageIndex == pageCount ? limit : pageIndex * step
    const items = tabPanel.querySelectorAll('.grid__item')
    const counter = tabPanel.querySelector('.counter')

    if (items.length) {
      for (let i = startRange + 1; i <= endRange; i++) {
        if (items[i - 1]) {
          items[i - 1].classList.remove('hidden')
        }
      }
    }

    if (counter) {
      counter.textContent = `Showing ${endRange} of ${limit}`
    }

    return pageIndex
  }

  showLoadMore(pageCount, pageIndex, loadMore) {
    if (loadMore) {
      if (pageCount === pageIndex) {
        loadMore.classList.add('hidden')
      } else {
        loadMore.classList.remove('hidden')
      }
    }
  }

  debounce = (fn, wait) => {
    let t
    return (...args) => {
      clearTimeout(t)
      t = setTimeout(() => fn.apply(this, args), wait)
    }
  }
}

customElements.define('main-search', MainSearch)
